import { Component, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatTableDataSource, MatSort, MatDialogRef } from '@angular/material';
import { RBTeamMember } from 'src/app/team/Models/Team';
import { Router } from '@angular/router';

@Component({
    selector: 'member-listbox',
    templateUrl: './member-listbox.component.html',
    styleUrls: ['./member-listbox.component.scss']
})

export class MemberListBoxComponent {
    TeamMembers: MatTableDataSource<RBTeamMember>;
    columns: string[] = ['fullName'];
    @ViewChild(MatSort) sorting: MatSort;

    addedMemberList: RBTeamMember[] = [];

    constructor(
        @Inject(MAT_DIALOG_DATA) public members: RBTeamMember[], private dialogRef: MatDialogRef<MemberListBoxComponent>,
        private _router: Router
    ) {
        this.TeamMembers = new MatTableDataSource<RBTeamMember>(this.members);
        setTimeout(() => {
            this.TeamMembers.sort = this.sorting;
        })
    }

    closeRedirect() {
        this._router.navigate(['/dashboard/teammembers/add']);
        this.dialogRef.close()
    }

    searchMemberToLink(searchStr: string) {
        this.TeamMembers.filter = searchStr;
    }

    linkMemberToRegion(member) {
        // Serch selected member index
        let index = this.TeamMembers.data.findIndex(x => x.teammemberID === member.teammemberID);
        this.TeamMembers.data[index]['visible'] = true;

        // Collect to local array
        this.addedMemberList.push(this.TeamMembers.data[index]);

        // Delete from current list
        this.TeamMembers.data.splice(index, 1);
        this.TeamMembers.sort = this.sorting;
    }
}